import type { WhereSqlTransformer } from "@/types/workspace";
import { Textarea } from "@mantine/core";
import { useEffect, useState } from "react";
import { TransformerBase } from "./TransformerBase";

export function TransformerWhereSql({
  data,
  warning,
  error,
  onUpdate,
}: {
  data: WhereSqlTransformer;
  warning?: string;
  error?: string;
  onUpdate?: (updatedData: WhereSqlTransformer) => void;
}) {
  const [where, setWhere] = useState(data.where || "");

  useEffect(() => {
    setWhere(data.where || "");
  }, [data.where]);

  const handleWhereChange = (value: string) => {
    setWhere(value);
    if (onUpdate) {
      onUpdate({
        ...data,
        where: value,
      });
    }
  };

  return (
    <TransformerBase warning={warning} error={error}>
      <Textarea
        variant="unstyled"
        placeholder="Enter SQL"
        value={where}
        onChange={(e) => handleWhereChange(e.target.value)}
        autosize
        minRows={1}
        maxRows={10}
      />
    </TransformerBase>
  );
}
